import { EntityModel } from '@/interfaces'
import {
  ALL_ACCORDION_BLOCK_ITEMS_QUERY,
  CREATE_ACCORDION_BLOCK_ITEM_MUTATION,
  DELETE_ACCORDION_BLOCK_ITEM_MUTATION,
  FORCE_DELETE_ACCORDION_BLOCK_ITEM_MUTATION,
  SINGLE_ACCORDION_BLOCK_ITEM_QUERY,
  UPDATE_ACCORDION_BLOCK_ITEM_MUTATION,
} from './graphql'

const cmsAccordionBlockItemModel: EntityModel = {
  name: 'accordionBlockItem',
  namePlural: 'accordionBlockItems',
  uniqueName: 'cmsAccordionBlockItem',
  uniqueNamePlural: 'cmsAccordionBlockItems',
  path: 'cms/blocks/accordion_block_item',
  baseUrl: '/cms/blocks/accordion_block_items',
  translationPrefix: 'entities:cmsAccordionBlockItem.',
  getDisplayName: (values: any) => {
    return 'Accordion Block Item'
  },
  gql: {
    getAll: ALL_ACCORDION_BLOCK_ITEMS_QUERY,
    getSingle: SINGLE_ACCORDION_BLOCK_ITEM_QUERY,
    create: CREATE_ACCORDION_BLOCK_ITEM_MUTATION,
    update: UPDATE_ACCORDION_BLOCK_ITEM_MUTATION,
    delete: DELETE_ACCORDION_BLOCK_ITEM_MUTATION,
    forceDelete: FORCE_DELETE_ACCORDION_BLOCK_ITEM_MUTATION,
  },
  attributes: {
    title: {
      name: 'title',
      label: 'entities:cmsAccordionBlockItem.attributes.title.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    content: {
      name: 'content',
      label: 'entities:cmsAccordionBlockItem.attributes.content.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'wysiwyg',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default cmsAccordionBlockItemModel
